import axios from 'axios';
const API_PREFIX = process.env.REACT_APP_API_PREFIX;

export const getOne = async (id) => {
  return await axios
    .get(`${API_PREFIX}/submissions/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

export const getAdminOne = async (id, center_cordinator_id) => {
  return await axios
    .get(`${API_PREFIX}/submissions/${id}/${center_cordinator_id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

export const AdminUpdate = async (id, payload, center_cordinator_id) => {
  return await axios
    .post(`${API_PREFIX}/submissions/${id}/${center_cordinator_id}`, payload)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      Promise.reject(error?.response.data);
    });
};

export const update = async (id, payload) => {
  return await axios
    .post(`${API_PREFIX}/submissions/${id}`, payload)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};

// For Candidate
export const getAllCandidate = async (id, shift, filter = {}) => {
  try {
    // Filter out undefined, null, or empty values from filter
    const validFilters = Object.fromEntries(
      Object.entries(filter).filter(([_, v]) => v !== undefined && v !== '')
    );

    // Construct query parameters dynamically, including shift only if it's valid
    const queryParams = new URLSearchParams({
      exam_day_id: id,
      ...(shift ? { shift } : {}), // Include shift only if it's not empty
      ...validFilters, // Include only valid filter values
    }).toString();

    // Make API request with filtered query parameters
    const response = await axios.get(`${API_PREFIX}/candidate/?${queryParams}`);

    return response.data;
  } catch (error) {
    return Promise.reject(error?.response?.data);
  }
};

// For Candidate
export const getAllCandidateAdmin = async (
  id,
  center_cordinator_id,
  shift,
  filter = {}
) => {
  try {
    // Filter out undefined, null, or empty values from filter
    const validFilters = Object.fromEntries(
      Object.entries(filter).filter(([_, v]) => v !== undefined && v !== '')
    );

    // Construct query parameters dynamically, including shift only if it's valid
    const queryParams = new URLSearchParams({
      exam_day_id: id,
      center_cordinator_id: center_cordinator_id,
      ...(shift ? { shift } : {}), // Include shift only if it's not empty
      ...validFilters, // Include only valid filter values
    }).toString();

    // Make API request with filtered query parameters
    const response = await axios.get(`${API_PREFIX}/candidate/?${queryParams}`);

    return response.data;
  } catch (error) {
    return Promise.reject(error?.response?.data);
  }
};

export const getAllCandidateForSaDashboard = async (filter) => {
  try {
    const queryParams = new URLSearchParams(filter).toString();
    const response = await axios.get(
      `${API_PREFIX}/candidate/super/?${queryParams}`
    );
    return response.data;
  } catch (error) {
    return Promise.reject(error?.response?.data);
  }
};

export const getCandidateById = async (id) => {
  return await axios
    .get(`${API_PREFIX}/candidate/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const createCandidate = async (payload) => {
  return await axios
    .post(`${API_PREFIX}/candidate/create-aadhar-bypass`, payload)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const updateCandidate = async (id, payload) => {
  return await axios
    .put(`${API_PREFIX}/candidate/${id}`, payload)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
export const removeCandidate = async (id) => {
  return await axios
    .delete(`${API_PREFIX}/candidate/${id}`)
    .then((res) => {
      return res.data;
    })
    .catch((error) => Promise.reject(error?.response.data));
};
